import type { Order } from "@/features/orders/types/order.types";
import { api } from "@/shared/api/instance";
import type { PaginatedResponse } from "@/shared/types/paginatedResponse";
import type { NotificationsResponse } from "../types";

export type NotificationsQuery = {
  airline?: string;
  page?: number;
  pageSize?: number;
  dateFrom?: string;
  dateTo?: string; 
  fromIata?: string;
  toIata?: string;
  status: string;
};

export const getNotifications = async (
  query: NotificationsQuery
): Promise<NotificationsResponse> => {
  const response = await api.get<NotificationsResponse>(
    "/api/v1/announcement",
    {
      params: query,
    }
  );

  return response.data;
};
export interface Payload {
  airline?: string;
  arrivalCity?: string;
  country?: string;
  departureCity?: string;
  departureDate?: string;
  flightCode?: string;
  flightNumber?: string;
  passengerType?: string;
  paymentStatus?: string;
}

export interface AnnouncementPayload {
  title: string;
  message: string;
  payload: Payload;
}

export interface SearchUsersResponse {
  recipientsCount: number;
}

export const createNotification = async (
  data: AnnouncementPayload
): Promise<void> => {
  await api.post("/api/v1/announcement", data);
};

export const resendNotification = async (
  id: number
): Promise<any> => {
  const response = await api.post(`/api/v1/announcement/${id}/resend`);
  return response.data
};
export const checkCSV = async (
  data: AnnouncementPayload
): Promise<void> => {
  await api.post("/api/v1/announcement", data);
};

export const searchUsers = async (
  data: Payload
): Promise<SearchUsersResponse> => {
  const response = await api.post(
    "/api/v1/announcement/recipients-count",
    data
  );
  return response.data;
};

const getFilenameFromDisposition = (cd?: string) => {
  if (!cd) return null;

  // content-disposition: attachment; filename="file.csv"
  const m = /filename\*?=(?:UTF-8''|")?([^;"\n]+)"?/i.exec(cd);
  return m?.[1] ? decodeURIComponent(m[1]) : null;
};


export const exportNotification = async () => {
  const res = await api.get("/api/v1/announcement/export", {
    responseType: "blob",
    headers: {
      Accept: "text/csv", // просим CSV [web:199]
    },
  });

  const cd = res.headers["content-disposition"];
  const filename =
    getFilenameFromDisposition(cd) ?? "notification-export.csv";

  // на всякий случай приводим к правильному mime
  const blob = new Blob([res.data], { type: "text/csv;charset=utf-8" }); // charset опционален [web:199]

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
